"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItemBase = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var context_1 = require("./context");
var Text_1 = __importDefault(require("../../Text"));
var layout_1 = require("../../layout");
var style_1 = require("../../../style");
var icons_1 = require("../../../icons");
var variables_1 = require("../../../style/variables");
var Accordion = function (_a) {
    var _b = _a.value, value = _b === void 0 ? {} : _b, onChange = _a.onChange, _c = _a.allowMultiple, allowMultiple = _c === void 0 ? true : _c, children = _a.children, props = __rest(_a, ["value", "onChange", "allowMultiple", "children"]);
    var toggleItem = react_2.useCallback(function (name) {
        var _a, _b;
        if (allowMultiple) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), (_a = {}, _a[name] = !value[name], _a)));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange((_b = {}, _b[name] = !value[name], _b));
        }
    }, [value, onChange, allowMultiple]);
    var contextValue = react_2.useMemo(function () { return ({ expandedState: value, toggleItem: toggleItem }); }, [value, toggleItem]);
    return (react_1.jsx(context_1.AccordionContextProvider, { value: contextValue },
        react_1.jsx("div", __assign({}, props), children)));
};
var itemStyles = {
    container: react_1.css({
        cursor: 'pointer',
        padding: '12px 16px',
        borderTop: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
        backgroundColor: 'white',
        color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
        outline: 'none',
        transition: 'all 0.3s ease',
    }),
    disabled: react_1.css({
        backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        cursor: 'not-allowed',
        pointerEvents: 'none',
        color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
    }),
};
var DEFAULT_STYLE_CONFIG = {
    default: react_1.css({
        '&:hover': {
            color: style_1.DesignSystemThemeColor.Primary.LIGHT_1,
            borderColor: style_1.DesignSystemThemeColor.Primary.LIGHT_1,
        },
        '&:focus-visible': {
            boxShadow: '0px 0px 0px 4px #CCF0FD',
            color: style_1.DesignSystemThemeColor.Primary.LIGHT_1,
            borderColor: style_1.DesignSystemThemeColor.Primary.LIGHT_1,
        },
    }),
    expanded: react_1.css({
        backgroundColor: style_1.DesignSystemThemeColor.Primary.LIGHT_6,
        color: style_1.DesignSystemThemeColor.Gray.DARK_4,
    }),
    disabled: react_1.css({
        backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        cursor: 'not-allowed',
        color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
    }),
};
var AccordionItemBase = function (_a) {
    var name = _a.name, title = _a.title, children = _a.children, Icon = _a.icon, disabled = _a.disabled, after = _a.after, _b = _a.expandIcon, expandIcon = _b === void 0 ? react_1.jsx(icons_1.ChevronDown, { size: 24 }) : _b, _c = _a.collapseIcon, collapseIcon = _c === void 0 ? react_1.jsx(icons_1.ChevronUp, { size: 24 }) : _c, _d = _a.styleConfig, styleConfig = _d === void 0 ? DEFAULT_STYLE_CONFIG : _d;
    var _e = context_1.useAccordionContext(), expandedState = _e.expandedState, toggleItem = _e.toggleItem;
    var expanded = react_2.useMemo(function () { return expandedState[name]; }, [expandedState, name]);
    return (react_1.jsx("div", { css: {
            backgroundColor: '#fff',
            cursor: disabled ? 'not-allowed' : undefined,
        } },
        react_1.jsx(layout_1.Flex, { onClick: disabled ? undefined : function () { return toggleItem(name); }, alignItems: "center", gap: 8, css: [
                itemStyles.container,
                styleConfig.default,
                expanded ? styleConfig.expanded : undefined,
                disabled ? itemStyles.disabled : undefined,
                disabled ? styleConfig.disabled : undefined,
            ], tabIndex: 0, disabled: disabled, role: "button" },
            Icon ? react_1.jsx(Icon, { size: 20, css: { marginRight: 2 } }) : null,
            react_1.jsx(Text_1.default.Title, { color: "inherit", css: { flex: 1 } }, title || name),
            after,
            expanded ? collapseIcon : expandIcon),
        expanded ? children : null));
};
exports.AccordionItemBase = AccordionItemBase;
var AccordionItem = exports.AccordionItemBase;
exports.default = Object.assign(Accordion, { Item: AccordionItem });
